import React, { PureComponent } from 'react';
import { isNumber } from 'lodash';
import PropTypes from 'prop-types';
import HeatmapLayer from 'react-leaflet-heatmap-layer';
import { connect } from 'react-redux';

import { setMapLegend } from 'action-creators/chart';

class GeoheatMapItem extends PureComponent {
  static propTypes = {
    _id: PropTypes.string,
    data: PropTypes.array.isRequired,
    onLegendUpdate: PropTypes.func,
    autoViewport: PropTypes.bool,
    viewport: PropTypes.object,

    // GeoHeatmap options
    blur: PropTypes.number,
    radius: PropTypes.number,
    gradient: PropTypes.object,
    opacity: PropTypes.number,
    aggregateType: PropTypes.string,
    minOpacity: PropTypes.number,
    useLocalExtrema: PropTypes.bool,
  };

  static defaultProps = {
    blur: 25,
    radius: 30,
    opacity: 1,
    useLocalExtrema: true,
  };

  constructor(props) {
    super(props);

    this.minMaxState = {
      min: Number.MAX_SAFE_INTEGER,
      max: Number.MIN_SAFE_INTEGER,
    };
  }

  getLegends = ({ min, max }) => {
    if (this.minMaxState.max === max && this.minMaxState.min === min) {
      return;
    }

    this.minMaxState = {
      min,
      max,
    };

    const { _id, onLegendUpdate } = this.props;

    if (_id !== undefined && isNumber(min) && isNumber(max)) {
      return onLegendUpdate(_id, min, max);
    }
  };

  render() {
    const {
      data,
      aggregateType,
      opacity,
      blur,
      radius,
      gradient,
      autoViewport,
      useLocalExtrema,
    } = this.props;

    const heatmapProps = {
      aggregateType,
      opacity,
      blur,
      radius,
      gradient,
      fitBoundsOnLoad: autoViewport,
      useLocalExtrema,
    };

    return (
      <HeatmapLayer
        points={data}
        onStatsUpdate={this.getLegends}
        longitudeExtractor={marker => marker.coordinates[1]}
        latitudeExtractor={marker => marker.coordinates[0]}
        intensityExtractor={marker => marker.intensity}
        {...heatmapProps}
      />
    );
  }
}

const ConnectedGeoheatMapItem = connect(
  null,
  { onLegendUpdate: setMapLegend }
)(GeoheatMapItem);

export default ConnectedGeoheatMapItem;
export { GeoheatMapItem };
